var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppCore',{attrs:{"appName":"ecommerce","onlyLanguage":false,"summaryBehavior":_vm.$store.state.systemStore.summaryBehavior},on:{"config-ready":_vm.loadApi}})
}
var staticRenderFns = []

export { render, staticRenderFns }